/**
 * @generated SignedSource<<b49791056f521b0de201e5b386773155>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsPullRequestApprovalStatus = "APPROVED" | "NEEDSWORK" | "UNAPPROVED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type reviewersCell_softwareCodePage$data = {
  readonly reviewers: ReadonlyArray<{
    readonly approvalStatus: DevOpsPullRequestApprovalStatus | null | undefined;
    readonly user: {
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined>;
  readonly " $fragmentType": "reviewersCell_softwareCodePage";
};
export type reviewersCell_softwareCodePage$key = {
  readonly " $data"?: reviewersCell_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reviewersCell_softwareCodePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "reviewersCell_softwareCodePage",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "DevOpsReviewer",
        "kind": "LinkedField",
        "name": "reviewers",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "approvalStatus"
          },
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "reviewers"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "bd4547f02cb3b77ae60545435ee9006e";

export default node;
